import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { PaymentMethodButtonBox } from 'src/ui/components/list-item/actionable/payment-method/PaymentMethod.style';

interface PaymentMethodButtonType {
    isSignup: boolean;
    onClick: () => void;
    children: React.ReactNode;
    disabled?: boolean;
    dataTest: string;
}

export const PaymentMethodButton = observer(
    'PaymentMethodButton',
    ({ isSignup, children, onClick, disabled = false, dataTest }: PaymentMethodButtonType): JSX.Element => {
        return (
            <PaymentMethodButtonBox
                isSignup={isSignup}
                onClick={onClick}
                disabled={disabled}
                data-test={dataTest}
            >
                {children}
            </PaymentMethodButtonBox>
        );
    }
);
